import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module'; // Import SharedModule
import { HttpClientModule, HttpClientXsrfModule, HttpXsrfTokenExtractor, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { JwtInterceptor } from './core/interceptors/jwt-interceptor';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { CRFInterceptor } from './core/interceptors/crf-interceptor';
import { DEFAULT_TIMEOUT, TimeoutInterceptor } from './core/interceptors/timeout-interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { StudentCompletedSurveyComponent } from './student-completed-survey/student-completed-survey.component';
import { MaintenanceInterceptor } from './core/interceptors/maintenance.interceptor';
import { MaintenanceComponent } from './maintenance/maintenance.component';

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
	StudentCompletedSurveyComponent,
	MaintenanceComponent
  ],
  imports: [
    HttpClientXsrfModule.withOptions({
			cookieName: 'XSRF-TOKEN',
			headerName: 'X-XSRF-TOKEN'
		}),
		HttpClientModule,
		AppRoutingModule,
		BrowserAnimationsModule,
		ReactiveFormsModule,
		FormsModule,
    AppRoutingModule,
    SharedModule, // Add SharedModule to imports array
	ToastrModule.forRoot()
  ],
  providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: JwtInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: ErrorInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: MaintenanceInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: CRFInterceptor,
			multi: true
		},
		[{ 
			provide: HTTP_INTERCEPTORS, 
			useClass: TimeoutInterceptor, 
			multi: true 
		}],
		[{ 
			provide: DEFAULT_TIMEOUT, 
			useValue: 30000 
		}]
	],
  bootstrap: [AppComponent]
})
export class AppModule { }
